import styled from 'styled-components';

const OptionsStepContainer = styled.div`
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export default OptionsStepContainer;